import React, { useEffect, useState } from 'react';
import './Feedback.scss'

const Feedback = (props) => {

    const { data } = props
    /** States */
    const [result, setResult] = useState()

    useEffect(()=> {
        
        // if(data.success) setResult(true)

    },[data])

    return (
        <div className='feedback'  >
                <p>your satelite achieved all its mission objectives time fror champagne!
                here are notes on your satellite's result
            </p>
        </div>
    )

}

export default Feedback;